<template>
	<SOSlotModal
		:modal-title="'Hapus Pengingat'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="f-regular f-16 f-c-black">
				Yakin ingin menghapus pengingat masa aktif ini?
			</div>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Ya, Hapus'"
				:outline="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled"
				:loading="pageSetting.btn.save.loading"
				@action="action"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputTime from "@/so-components/global/input/SOInputTime";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "HapusReminderModal",
	components: {
		SOSlotModal,
		SOInputSelect,
		SOInputTime,
		SOButton,
	},
	computed: {
		...mapGetters("pengaturanUmumModule", {
			reminderOption: "reminderOption",
		})
	},
	props: {
		reminderId: {
			type: String,
			default: "",
		},
		reminderType: {
			type: String,
			default: "",
		}
	},
	data() {
		return {
			id: "modal-hapus-pengingat",
			pageSetting: {
				btn: {
					save: {
						disabled: false,
						loading: false,
					}
				}
			},
			options: [],
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		...mapActions("pengaturanUmumModule", {
			getInfo: "getReminderInfo",
		}),
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		async action() {
			let form = new FormData
			form.append("idpengingat", this.reminderId)
			form.append("type", this.reminderType)
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const action = this.reminderType == 'poin' ? 'pengaturanUmumModule/deleteReminderPoin' : 'pengaturanUmumModule/deleteReminder'
			const payload = this.reminderType == 'poin' ? this.reminderId : form
			const res = await this.$store.dispatch(action, payload)
			if (res.success) {
				this.$toast.success(res.msg)
				this.close()
			} else {
				this.$toast.error(res.err)
			}
			await this.getInfo()
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
		},
	}
}
</script>